export default __webpack_public_path__ + "e498fe16d75cd60817d133449216c39c.png";